<template>
  <section class="data-table" :class="{'data-table_open': showRight && activeUser}">
    <div>
      <h2 class="title">{{invitedUsers.length}} {{postfix}}
      </h2>

      <div class="user-header">
        <button @click="addUser"
                class="accent-button">
          {{$t('users.inviteUser')}}
        </button>
        <button type="button"
                @click="checkDelUsers"
                v-if="checkedUsers.length > 0"
                class="control-btn hover-red">
          <del-icon></del-icon>
        </button>
        <button type="button"
                @click="showRightInfo('')"
                v-if="!showRight && checkedUsers.length == 1"
                class="btn about-btn btn-transparent_dark">
          <chevron-icon :fill="'rgba(0, 82, 127, .5)'"></chevron-icon>
          {{$t('btns.more')}}
        </button>
        <button v-if="showRight"
                @click="closeRightInfo"
                class="btn about-btn_close btn-transparent_blue">
          <chevron-icon :fill="'rgba(16, 156, 241, 1)'"></chevron-icon>
        </button>
      </div>
    </div>

    <table-component :legend="createLegend()"
                     :clear-checked="clearMarker"
                     :is-user-page="true"
                     :open-user="showRight"
                     :class-name="'users-table'"
                     :column-width="columnWidth"
                     :all-checked="allChecked"
                     :columns="columns"
                     @filterName="filterName($event)"
                     @filterMail="filterMail($event)"
                     @filterReg="filterReg($event)"
                     @filterRoles="filterRoles($event)"
                     @showRightInfo="showRightInfo($event)"
                     @changeCheckbox="checkedUsers = $event"
                     @sendReinviteMail="sendReinviteMail($event)"
                     @checkAll="checkAll"></table-component>
  </section>
</template>

<script>
  import { filters } from "../../../mixins/filters";
  import {tokenAndRoute} from "../../../mixins/utils/tokenAndRoute";
  import {checkedClass} from "../../../mixins/utils/checkedClass";
  import {showOverlay} from "../../../mixins/utils/showOverlay";

  import delIcon from '../../Svg/cart_control/delIcon'
  import chevronIcon from '../../Svg/chevronIcon'
  import groupIcon from '../../Svg/cart_control/groupIcon'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {delItem2} from "../../../mixins/delItem2";
  import filterIcon from '../../Svg/filterIcon'
  import {loaderMixin} from "../../../mixins/utils/loaderMixin";
  import {tableComponentMixin} from "../../../mixins/utils/tableComponentMixin";

  export default {
    name: 'data-table',
    components: {
      delIcon,
      chevronIcon,
      groupIcon,
      filterIcon
    },
    mixins: [filters, tokenAndRoute, showOverlay, delItem2, loaderMixin, checkedClass, tableComponentMixin],
    data: function () {
      return {
        dateFilters: filters,
        checkedUsers: [],
        savedUser: '',

        activeName: false,
        nameUp: true,
        nameDown: true,

        mailActive: false,
        mailUp: true,
        mailDown: true,

        regActive: false,
        regUp: true,
        regDown: true,

        rolesActive: false,
        rolesUp: true,
        rolesDown: true,

        legend: [],
        clearMarker: false,
      }
    },
    computed: {
      ...mapState({
        invitedUsersData: state => state.roles.invitedUsers,
        assignedUsersData: state => state.roles.users,
        ownedRoles: state => state.roles.ownedRoles,
        showRight: state => state.users.showInfo,
        activeUser: state => state.users.rightInfo,
        updateRightInfo: state => state.users.reloadUserRight
      }),
      columnWidth() {
        if (this.showRight) {
          return [(254/(1100 - 525) * 100), (248/(1100 - 525) * 100), (219/(1100 - 525) * 100), (360/(1100 - 525) * 100)]
        } else {
          return [254/1100 * 100, 248/1100 * 100, 219/1100 * 100, 360/1100 * 100]
        }
      },
      columns() {
        return this.invitedUsers.map(item => {
          return {
            id: item.id,
            item,
            cells: [
              {
                text: {
                  text: `${item.first_name ? item.first_name : ''} ${item.second_name ? item.second_name : ''}`,
                  isLink: false
                },
                avatar: {
                  isAvatar: true,
                  avatarLink: item.contacts.avatar_url
                },
                isMethod: true,
                method: {
                  name: 'showRightInfo',
                  text: `${item.first_name ? item.first_name : ''} ${item.second_name ? item.second_name : ''}`,
                  colorMethod: false,
                  methodProps: item
                }
              },
              {
                text: {
                  isLink: true,
                  text: item.contacts.email,
                  link: `mailto:${item.contacts.email}`,
                  linkColor: false,
                },
                avatar: {
                  isAvatar: false
                },
              },
              {
                text: {
                 text: '',
                 isLink: false
                },
                avatar: {
                 isAvatar: false
                },
                isMethod: true,
                method: {
                  name: item.status != 0 ? '' : 'sendReinviteMail',
                  text: item.status != 0 ? this.timestampToData(item.created_at) : this.$t('users.repeatInvie'),
                  colorMethod: item.status != 0 ? false : true,
                  methodProps: item.status != 0 ? '' : item.contacts.email
                }
              },
              {
                text: {
                  text: (item.roles && item.roles.length > 0) ? '' : this.$t('users.noRole'),
                  isLink:  (item.roles && item.roles.length > 0) ? true : false,
                  isApp: true,
                  linkArr: true,
                  isTrimmed: true,
                  trimWidth: 25,
                  link: {
                      linkPrefix: `/roles/role/`,
                      arr: this.returnUserRoles(item.roles),
                      linkIndex: 'id',
                      linkText: 'name'
                  },
                  linkColor: true,
                },
                avatar: {
                  isAvatar: false
                }
              }
            ]
          }
        })
      },
      invitedUsers() {
        let groupId = this.routeId;
        let users = this.assignedUsersData.concat(this.invitedUsersData)
        let usersData = this.delDouble(users,'contacts', 'email');

        if (groupId) {
          let arr = [];

          for (let i = 0; i < usersData.length; i++) {
            let item = usersData[i];
            for (let j = 0; j < item.roles.length; j++) {
              if(item.roles[j].group_id == groupId) {
                arr.push(item)
              }
            }
          };
          document.title = `OmniioTh | Пользователи`;
          usersData = arr;
        };

        if (this.activeName) {
          usersData.sort((a,b) => {
            let nameA = a.first_name;
            if (nameA == null) {
              nameA = ' '
            };
            let nameB = b.first_name;
            if (nameB == null) {
              nameB = ' '
            };

            if (this.nameDown) {
              if (nameA > nameB) return 1;
              if (nameA < nameB) return -1;
              return 0;
            };

            if (this.nameUp) {
              if (nameA < nameB) return 1;
              if (nameA > nameB) return -1;
              return 0;
            }
          })
        };

        if (this.mailActive) {
          usersData.sort((a,b) => {
            let mailA = a.contacts.email;
            let mailB = b.contacts.email;

            if (this.mailDown) {
              if (mailA > mailB) return 1;
              if (mailA < mailB) return - 1;
              return 0;
            };

            if (this.mailUp) {
              if (mailA < mailB) return 1;
              if (mailA > mailB) return -1;
              return 0;
            }
          })
        };

        if (this.regActive) {
          usersData.sort((a,b) => {
            let regA = a.created_at;
            let regB = b.created_at;

            if (this.regDown) {
              if (regA > regB) return 1;
              if (regA < regB) return -1;
              return 0;
            };

            if (this.regUp) {
              if (regA < regB) return 1;
              if (regA > regB) return -1;
              return 0;
            }
          })
        };

        if (this.rolesActive) {
          usersData.sort((a,b) => {
            let rolesA = a.roles.length;
            let rolesB = b.length;

            if (this.rolesDown) {
              if (rolesA > rolesB) return 1;
              if (rolesA < rolesB) return -1;
              return 0;
            };

            if (this.rolesUp) {
              if (rolesA < rolesB) return 1;
              if (rolesA > rolesB) return -1;
              return 0;
            }
          })
        }

        return usersData
      },
      allChecked() {
        return this.invitedUsers.length === this.checkedUsers.length && this.checkedUsers.length > 0
      },
      postfix() {
        if (this.invitedUsers) {
          let length = this.invitedUsers.length;
          length = String(length).slice(-1);
          if (length == 0 || length >= 5) {
            return this.$t('users.postfix10') //пользователей
          };
          if (length == 1) {
            return this.$t('users.postFix1') //пользователь

          };
          if (length > 1 && length < 5) {
            return this.$t('users.postfix5') //пользователя
          }
        }
      },
    },
    watch: {
      updateRightInfo(val) {
        if (val) {
          let id = this.savedUser;
          let itemData;
          for (let i = 0; i < this.invitedUsers.length; i++) {
            if (this.invitedUsers[i].id == id) {
              itemData = this.invitedUsers[i];
              break;
            }
          }
          this.setRightInfo(itemData)
        }
      }
    },
    methods: {
      ...mapMutations({
        setShowRight: 'users/SET_SHOW_INFO',
        setRightInfo: 'users/SET_RIGHT_INFO',
        showAddUserPopup: 'popups/addUser/SET_SHOW'
      }),
      ...mapActions({
        deleteRoleAssignment: 'roles/deleteRoleAssignment',
        getUsers: 'roles/getUsers',
        getInvitedUsers: 'roles/getInvitedUsers',
        getOwnedRoles: 'roles/getOwnedRoles',
        reinviteUser: 'roles/reinviteUser',
        deleteUser: 'roles/deleteUser',
        rejectInvite: 'roles/rejectInvite'
      }),
      createLegend() {
        return this.legend = [
          {
            text: this.$t('users.table.contactPerson'),
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false,
            filterMethod: 'filterName'
          },
          {
            text: this.$t('users.table.email'),
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false,
            filterMethod: 'filterMail'
          },
          {
            text: this.$t('users.registered'),
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false,
            filterMethod: 'filterReg'
          },
          {
            text: this.$t('index.users.title'),
            legendSort: true,
            legendDown: true,
            legendUp: true,
            activeFilter: false,
            filterMethod: 'filterRoles'
          }
        ]
      },
      checkUserHandler(e) {
        let item = e.target.parentElement.parentElement.parentElement;
        this.toggleClass(item, 'user-item_checked')
      },
      filterName(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.activeName = true;
        this.mailActive = false;
        this.regActive = false;
        this.rolesActive = false;
        this.mailUp = true;
        this.mailDown = true;
        this.regUp = true;
        this.regDown = true;
        this.rolesUp = true;
        this.rolesDown = true;

        if (this.nameUp && this.nameDown) {
          this.nameDown = true;
          this.nameUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.nameUp) {
          this.nameUp = false;
          this.nameDown = true;
          this.setLegendDown(index);
          this.setLegendArr()
          return;
        }

        if (this.nameDown) {
          this.nameDown = false;
          this.nameUp = true;
          this.setLegendUp(index);
          this.setLegendArr();
          return;
        }
      },
      filterMail(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.mailActive = true;
        this.activeName = false;
        this.regActive = false;
        this.rolesActive = false;
        this.nameUp = true;
        this.nameDown = true;
        this.regUp = true;
        this.regDown = true;
        this.rolesUp = true;
        this.rolesDown = true;

        if (this.mailUp && this.mailDown) {
          this.mailDown = true;
          this.mailUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.mailUp) {
          this.mailUp = false;
          this.mailDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        }

        if (this.mailDown) {
          this.mailDown = false;
          this.mailUp = true;
          this.setLegendUp(index);
          this.setLegendArr();
          return;
        }
      },
      filterReg(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.regActive = true;
        this.activeName = false;
        this.mailActive = false;
        this.rolesActive = false;
        this.nameUp = true;
        this.nameDown = true;
        this.mailUp = true;
        this.mailDown = true;
        this.rolesUp = true;
        this.rolesDown = true;

        if (this.regUp && this.regDown) {
          this.regDown = true;
          this.regUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.regUp) {
          this.regUp = false;
          this.regDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        }

        if (this.regDown) {
          this.regDown = false;
          this.regUp = true;
          this.setLegendUp(index);
          this.setLegendArr();
          return;
        }
      },
      filterRoles(index) {
        this.copyLegend();
        this.setDefaultLegend();
        this.setActiveFilterLegend(index);

        this.rolesActive = true;
        this.activeName = false;
        this.mailActive = false;
        this.regActive = false;
        this.nameUp = true;
        this.nameDown = true;
        this.mailUp = true;
        this.mailDown = true;
        this.regUp = true;
        this.regDown = true;

        if (this.rolesUp && this.rolesDown) {
          this.rolesDown = true;
          this.rolesUp = false;
          this.setLegendDown(index);
          this.setLegendArr();
          return
        };

        if (this.rolesUp) {
          this.rolesUp = false;
          this.rolesDown = true;
          this.setLegendDown(index);
          this.setLegendArr();
          return;
        }

        if (this.rolesDown) {
          this.rolesDown = false;
          this.rolesUp = true;
          this.setLegendUp(index);
          this.setLegendArr();
          return;
        }
      },

      async sendReinviteMail(email) {
        this.showLoader();
        await this.reinviteUser({
          token: this.token,
          email
        });
        this.hideOnlyLoader();
      },
      checkAll() {
        if (!this.allChecked) {
          this.checkedUsers = this.invitedUsers;
          // this.addCheckedClass('.user-item', 'user-item_checked')
        } else {
          // this.removeCheckedClass('user-item_checked')
          this.checkedUsers = [];
        }
      },
      returnUserRoles(arr) {
        let arrResult = [];
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i].role_id;
          for (let j = 0; j < this.ownedRoles.length; j++) {
            let role = this.ownedRoles[j];
            if (role.id == item) {
              arrResult.push({id: role.id,name: `${role.name}`})
            }
          }
        };
        return arrResult
      },
      showRightInfo(item) {
        if (!item) {
          let item = this.checkedUsers[0];
          this.setRightInfo(item);
        } else {
          this.setRightInfo(item)
        };
        this.savedUser = item.id;
        this.setShowRight(true);
      },
      closeRightInfo() {
        this.setRightInfo('');
        this.setShowRight(false);
      },
      addUser() {
        this.showOverlay(true);
        this.showAddUserPopup(true);
      },
      checkDelUsers() {
        let string = '';
        this.checkedUsers.forEach(item => {
          string += `${item.contacts.email} `
        });

        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string);
        this.setNumberDel(2);
      },
      deleteItems2() {
        this.delUsers()
      },
      async delUsers() {
        this.showLoader();
        for (let i = 0; i < this.checkedUsers.length; i++) {
          let item = this.checkedUsers[i];
          if (this.activeUser == item) {
            this.setRightInfo('');
            this.setShowRight(false);
          };
          // await this.deleteUser({token: this.token, id: item.id})
          await this.deleteUser({token: this.token, id: item.id})
        };
        this.clearMarker = true;
        this.checkedUsers = [];
        this.clearMarker = false;
        this.hideLoader();
        this.getInvitedUsers(this.token);
        this.getUsers(this.token);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    font-family: $msb;
    font-size: 24px;
    letter-spacing: .25px;
    margin-bottom: 30px;
  }

  .user-header {
    display: flex;
    align-items: center;

    button {
      height: 40px;
    }

    .about-btn {
      margin-left: auto;
      width: 150px;

      svg {
        margin-right: 10px;
        transform: rotate(90deg);
      }
    }

    .about-btn_close {
      margin-left: 20px;
      width: 40px;

      svg {
        transform: rotate(-90deg);
      }

    }

  }

  .accent-button {
    margin-right: 30px;
  }

  .data-table {
    width: 100%;
  }

  .users-table {
    margin-top: 15px;

    .cell2 .item-desc {
      font-family: MM, Arial, sans-serif;
      font-size: 14px;
      letter-spacing: 0.25px;
      color: #00527F;
    }
  }
</style>
